// Imports
import { Container, ComponentWrapper } from "@/components";
import { FlippingBookEmbed } from "./FlippingBookEmbed";

const FLIPPINGBOOK_HOST = "online.flippingbook.com";

function getAttribute(markup, attribute) {
  const match = markup.match(
    new RegExp(
      `\\s${attribute}\\s*=\\s*(?:"([^"]*)"|'([^']*)'|([^\\s>]+))`,
      "i"
    )
  );

  return (match?.[1] ?? match?.[2] ?? match?.[3] ?? "").replaceAll(
    "&amp;",
    "&"
  );
}

function isFlippingBookUrl(value) {
  try {
    const url = new URL(value);
    return url.protocol === "https:" && url.hostname === FLIPPINGBOOK_HOST;
  } catch {
    return false;
  }
}

function getFlippingBookEmbed(code) {
  if (typeof code !== "string") return null;

  const anchor = [...code.matchAll(/<a\b[^>]*>[\s\S]*?<\/a>/gi)].find(
    ([markup]) => /\bclass\s*=\s*(["'])[^"']*\bfbo-embed\b[^"']*\1/i.test(markup)
  )?.[0];
  const script = [...code.matchAll(/<script\b[^>]*>/gi)].find(([markup]) =>
    isFlippingBookUrl(getAttribute(markup, "src"))
  )?.[0];

  if (!anchor || !script) return null;

  const href = getAttribute(anchor, "href");
  const embedId = getAttribute(anchor, "data-fbo-id");
  const scriptSrc = getAttribute(script, "src");

  if (
    !href ||
    !embedId ||
    !isFlippingBookUrl(href) ||
    !isFlippingBookUrl(scriptSrc)
  ) {
    return null;
  }

  return {
    href,
    embedId,
    scriptSrc,
    ratio: getAttribute(anchor, "data-fbo-ratio") || "3:2",
    lightbox: getAttribute(anchor, "data-fbo-lightbox") || "yes",
    width: getAttribute(anchor, "data-fbo-width") || "100%",
    height: getAttribute(anchor, "data-fbo-height") || "auto",
    version: getAttribute(anchor, "data-fbo-version") || "1",
    title: anchor.replace(/<[^>]+>/g, "").trim() || "Open publication",
  };
}

// Image
export function CodeEmbed({ type, code }) {
  const flippingBookEmbed = getFlippingBookEmbed(code);

  return (
    <ComponentWrapper type={type}>
      <Container>
        <div className="flex justify-center w-full">
          {flippingBookEmbed ? (
            <FlippingBookEmbed {...flippingBookEmbed} />
          ) : (
            <div
              className="w-full overflow-hidden rounded-base"
              dangerouslySetInnerHTML={{ __html: code }}
            />
          )}
        </div>
      </Container>
    </ComponentWrapper>
  );
}
